<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>사업장 정보</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_1"
            placeholder="선택"
          ></CompanySelector>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업주 또는 대표자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_4"
          />
        </div>
      </div>
    </div>

    <div class="mb-6">
      <p class="title mb-5">
        <i class="dot"></i>현장개요(*란은 원수급인 경우에만 작성)
      </p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장(현장)명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">발주자 또는 도급인</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">휴대폰번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">주소</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <span v-if="isPrint" class="print-input"> {{ form.inputC_6 }} </span>
          <search-nav-start-end
            v-else
            :readonly="board.readonly"
            class="input-se"
            label="공사기간"
            v-model="form.inputC_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">공사금액</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_7 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_7"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">상시근로자 수(명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_8 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_8"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">굴착길이(M)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">건축물·공작물의 최대높이(M)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">건축물의 연면적(㎡)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_11 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">건축물의 최대층고(M)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_12 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_12"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">Precast Concrete조립작업 유무*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_13 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_13"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">다리의 최대 지간길이(M)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_14 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_14"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">터널길이(M)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_15 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_15"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">댐의 용도 및 저수용량(TON)*</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputC_16 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputC_16"
          />
        </div>
      </div>
    </div>

    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>안전관리자(안전관리 전문기관)</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputD_7}} 년 {{form.inputD_8}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputD_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputD_8"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputD_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_11 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputD_12 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputD_12"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>보건관리자(보건관리 전문기관)</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputE_7}} 년 {{form.inputE_8}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputE_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputE_8"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_10 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputE_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_11 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_11"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputE_12 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputE_12"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <p class="title mb-5"><i class="dot"></i>산업보건의</p>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_1 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">기관명</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_2 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">이메일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_3 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_3"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">전화번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_4 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_4"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">자격/면허번호</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_5 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_5"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(기관명)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_6 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_6"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">경력(경력기간)</div>
          <span v-if="isPrint" class="print-input"> {{form.inputF_7}} 년 {{form.inputF_7_1}} 월</span>
          <div v-else class="w-full flex flex-1 items-center">
            <vs-input class="w-auto" v-model="form.inputF_7"/>
            <p class="ml-2 mr-2 text-center">년</p>
            <vs-input class="w-auto" v-model="form.inputF_7_1"/>
            <p class="ml-2 text-center">월</p>
          </div>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학교)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_8 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_8"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">학력(학과)</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_9 }} </span>
          <vs-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputF_9"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">선임일</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_10 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputF_10"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputF_11 }} </span>
          <action-type-division
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputF_11"
          />
        </div>
      </div>
    </div>
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import SearchNavStartEnd from '../../../list/components/SearchNavStartEnd.vue'
import FileUploadModule from '../../../modules/FileUploadModule.vue'
import ActionTypeDivision from '../../../../components/selector/ActionTypeDivision.vue'
import FieldSelectModule from '@/views/modules/FieldSelectModule'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    SearchNavStartEnd,
    FileUploadModule,
    ActionTypeDivision,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',
        inputC_6: {},
        inputC_7: '',
        inputC_8: '',
        inputC_9: '',
        inputC_10: '',
        inputC_11: '',
        inputC_12: '',
        inputC_13: '',
        inputC_14: '',
        inputC_15: '',
        inputC_16: '',

        inputD_1: '',
        inputD_2: '',
        inputD_3: '',
        inputD_4: '',
        inputD_5: '',
        inputD_6: '',
        inputD_7: '',
        inputD_8: '',
        inputD_9: '',
        inputD_10: '',
        inputD_11: '',
        inputD_12: '',

        inputE_1: '',
        inputE_2: '',
        inputE_3: '',
        inputE_4: '',
        inputE_5: '',
        inputE_6: '',
        inputE_7: '',
        inputE_8: '',
        inputE_9: '',
        inputE_10: '',
        inputE_11: '',
        inputE_12: '',

        inputF_1: '',
        inputF_2: '',
        inputF_3: '',
        inputF_4: '',
        inputF_5: '',
        inputF_6: '',
        inputF_7: '',
        inputF_7_1: '',
        inputF_8: '',
        inputF_9: '',
        inputF_10: '',
        inputF_11: '',

        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
